import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Cancel, PlaceholderImg, SearchIcon } from "../../../styled/AllImages";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LazyImage,
  SpanStyled,
} from "../../../styled/Elements";

import { useTranslation } from "react-i18next";
import { RadioButton } from "../../../styled/FormElements";
import styled from "styled-components";
import FloatingInput from "../../inputFields/FloatingInput";

const SingleUserModal = ({
  show,
  onHide,
  title,
  mainParents,
  pendingSelection,
  setPendingSelection,
  handleAddUserClick,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;

  const [filteredList, setFilteredList] = useState([]);

  const handleSearch = (e) => {
    const { value } = e.target;
    const searchQuery = value.toLowerCase();

    const updatedList = mainParents.filter((item) => {
      if (item.name) {
        return item.name.toLowerCase().includes(searchQuery);
      }
      return (
        item.name?.toLowerCase().includes(searchQuery) ||
        item.subLabel?.toLowerCase().includes(searchQuery)
      );
    });

    setFilteredList(updatedList);
  };

  useEffect(() => {
    setFilteredList(mainParents);
  }, [mainParents, show]);

  return (
    <Modal size="md" show={show} onHide={onHide} centered>
      <Box className="d-flex justify-content-between align-items-center p-3">
        <HeadingStyled size="24px" color="var(--text)">
          {title}
        </HeadingStyled>
        <span className="close-button cursor-pointer" onClick={onHide}>
          <Cancel />
        </span>
      </Box>
      <Box className="d-flex p-3 pt-0 border-bottom">
        <FloatingInput
          name="search"
          type="input"
          fieldType="text"
          label={t("search")}
          placeholder={t("search")}
          icon={SearchIcon}
          onChange={handleSearch}
        />
      </Box>
      <ScrollableContainer>
        {Array.isArray(filteredList) &&
          filteredList.length > 0 &&
          filteredList.map((mainParent) => (
            <SingleUserRow
              href="#!"
              className={`userDataRow ${
                pendingSelection?.id === mainParent.id && "selected"
              }`}
              key={mainParent.id}
            >
              <Box className="userDataContainer">
                <Box
                  className="userDataInfo cursor-pointer"
                  // onClick={() => onMainParentClick(mainParent)}
                >
                  <Box className="userDataImg">
                    <LazyImage
                      src={
                        mainParent?.profile
                          ? `${ASSET_URL}/${mainParent?.profile}`
                          : PlaceholderImg
                      }
                      alt="User"
                    />
                  </Box>
                  <Box className="userDataNameRole">
                    <SpanStyled
                      color="var(--text)"
                      size="16px"
                      weight="bold"
                      className=""
                    >
                      {mainParent?.name}
                    </SpanStyled>

                    {mainParent?.subLabel && (
                      <SpanStyled
                        color="var(--text2)"
                        size="14px"
                        className=""
                      >
                        {mainParent?.subLabel}
                      </SpanStyled>
                    )}
                  </Box>

                  <Box className="userDataCheckBox">
                    <RadioButton
                      type="radio"
                      name="user"
                      checked={pendingSelection?.id === mainParent?.id}
                      onChange={() => setPendingSelection(mainParent)} // Update pending user selection
                    />
                  </Box>
                </Box>
              </Box>
            </SingleUserRow>
          ))}
      </ScrollableContainer>
      <Box className="modal-footer">
        <ButtonStyled
          label={t("Cancel")}
          onClick={onHide}
          bg="var(--bgSecondary)"
          color="var(--text2)"
        />
        <ButtonStyled
          bg="var(--themeColor)"
          label={t("add")}
          onClick={handleAddUserClick} // Only add the user when the Add button is clicked
        />
      </Box>
    </Modal>
  );
};

export default SingleUserModal;
const SingleUserRow = styled.label`
  padding: 1rem;
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  cursor: pointer;
  /* &:hover{
    background-color: var(--bgSecondary);
  } */
  .userDataContainer {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
  .userDataInfo {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 16px;
    /* padding-right: 10px; */
    .userDataImg {
      display: block;
      min-width: 48px;
      max-width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    .userDataNameRole {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      span {
        width: 100%;
      }
    }
  }
  .userDataCheckBox {
    .customRadio label {
      padding-left: 26px;
    }
  }
`;

const ScrollableContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 10px;
  border-radius: 12px;
  padding: 8px;

  /* Scrollbar Styles */
  &::-webkit-scrollbar {
    width: 7px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: var(--bgSecondary);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e4e8ef;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #b8c0cc;
  }
`;
